import { render } from "./UserRegistrationChart.vue?vue&type=template&id=bf5674a8&scoped=true"
import script from "./UserRegistrationChart.vue?vue&type=script&lang=js"
export * from "./UserRegistrationChart.vue?vue&type=script&lang=js"

import "./UserRegistrationChart.vue?vue&type=style&index=0&id=bf5674a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf5674a8"]])

export default __exports__